<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="学期">
              <el-select v-model="selectedSemesterId" placeholder="学期" class="toolbar-field-w-lg"
                :disabled="!schoolId" @change="handleQuery">
                <el-option v-for="s in semesterList" :key="s.Id" :label="s.SemesterName" :value="s.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="家访类型">
              <el-select v-model="visitType" clearable placeholder="全部" class="toolbar-field-w-md" @change="handleQuery">
                <el-option label="首次家访" :value="1"></el-option>
                <el-option label="回访" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button v-for="item in actionButtonList" :key="item.id || item.Func"
              size="small"
              :type="toolbarBtnType(item)"
              :icon="toolbarBtnIcon(item)"
              :loading="!!item.loading"
              @click="btnClick(item)">{{ item.name }}</el-button>
          </div>
        </el-form>
      </div>
      <div v-if="classDepartmentId" class="hv-scope-tip">
        当前筛选班级：{{ className || classDepartmentId }}
        <el-button type="text" @click="clearClassFilter">查看全校</el-button>
      </div>

      <div class="hv-table-wrap">
        <el-table :data="users" v-loading="listLoading" stripe height="100%" style="width: 100%;">
        <el-table-column prop="GradeName" label="年级" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ClassName" label="班级" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="StudentCode" label="学号" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="StudentName" label="学生" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.VisitType === 2 ? 'warning' : 'success'" size="mini">
              {{ visitTypeLabel(scope.row.VisitType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="家访时间" width="155">
          <template slot-scope="scope">{{ formatDateTime(scope.row.VisitTime) }}</template>
        </el-table-column>
        <el-table-column prop="TeacherName" label="教师" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Address" label="定位地址" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="table-op-link--danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" :current-page="page" :page-size="pageSize"
          :total="total" style="float: right" @current-change="handleCurrentChange"></el-pagination>
      </el-col>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import { getButtonList } from "../../promissionRouter";
import toolbarFilterBarMixin from "@/mixins/toolbarFilterBarMixin";
import {
  getHomeVisitRecordPage,
  exportHomeVisitSummary,
  deleteHomeVisitRecord,
  downloadBlobExcel,
  loadHomeVisitSemesterList,
  onHomeVisitSchoolChange,
  resolveHomeVisitSchoolIdFromTreeNode,
  isHomeVisitClassDeptNode,
  visitTypeText
} from "@/api/homeVisit";

export default {
  mixins: [toolbarFilterBarMixin],
  components: { DepartmentPane },
  data() {
    return {
      DepartmentId: 0,
      schoolId: 0,
      classDepartmentId: 0,
      className: "",
      semesterList: [],
      selectedSemesterId: null,
      visitType: null,
      users: [],
      listLoading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      buttonList: [],
      actionButtonList: []
    };
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const buttonList = getButtonList(this.$route.path, routers);
    this.buttonList = buttonList;
    this.actionButtonList = (buttonList || []).filter((b) => b.Func !== "handleQuery");
  },
  methods: {
    visitTypeLabel: visitTypeText,

    formatDateTime(val) {
      if (!val) return "";
      return String(val).replace("T", " ").substring(0, 16);
    },

    async treeNodeClick(data, node) {
      if (isHomeVisitClassDeptNode(node)) {
        this.classDepartmentId = data.value;
        this.className = data.label || data.name || "";
        this.schoolId = resolveHomeVisitSchoolIdFromTreeNode(node, 0);
        this.DepartmentId = this.schoolId || data.value;
      } else {
        onHomeVisitSchoolChange(this, data.value);
        this.schoolId = resolveHomeVisitSchoolIdFromTreeNode(node, data.value);
        this.classDepartmentId = 0;
        this.className = "";
      }
      await loadHomeVisitSemesterList(this, this.schoolId || this.DepartmentId);
      this.handleQuery();
    },

    clearClassFilter() {
      this.classDepartmentId = 0;
      this.className = "";
      this.handleQuery();
    },

    handleQuery() {
      this.page = 1;
      this.getList();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },

    async getList() {
      if (!this.schoolId || !this.selectedSemesterId) {
        this.users = [];
        this.total = 0;
        return;
      }
      this.listLoading = true;
      try {
        const res = await getHomeVisitRecordPage({
          schoolDepartmentId: this.schoolId,
          semesterId: this.selectedSemesterId,
          classDepartmentId: this.classDepartmentId || undefined,
          visitType: this.visitType || undefined,
          page: this.page,
          pageSize: this.pageSize
        });
        const d = res.data;
        if (d.success && d.response) {
          this.users = d.response.data || [];
          this.total = d.response.dataCount || 0;
        } else {
          this.users = [];
          this.total = 0;
          this.$message.error(d.msg || "查询失败");
        }
      } finally {
        this.listLoading = false;
      }
    },

    btnClick(item) {
      if (!item || !item.Func) return;
      if (typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },

    handleExport() {
      if (!this.schoolId || !this.selectedSemesterId) {
        this.$message.warning("请先选择学校与学期");
        return;
      }
      exportHomeVisitSummary({
        schoolDepartmentId: this.schoolId,
        semesterId: this.selectedSemesterId
      })
        .then((res) => downloadBlobExcel(res, "家访汇总"))
        .catch(() => this.$message.error("导出失败"));
    },

    async handleDelete(row) {
      try {
        await this.$confirm("确认删除该家访记录？", "提示", { type: "warning" });
      } catch (e) {
        return;
      }
      const res = await deleteHomeVisitRecord(row.Id);
      const d = res.data;
      if (d.success) {
        this.$message.success(d.msg || "删除成功");
        this.getList();
      } else {
        this.$message.error(d.msg || "删除失败");
      }
    }
  }
};
</script>

<style scoped>
.hv-filter {
  flex: 0 0 auto;
  margin-bottom: 8px;
}
.hv-scope-tip {
  flex: 0 0 auto;
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}
.hv-table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.hv-table-wrap >>> .el-table {
  width: 100%;
  height: 100%;
}
</style>
